import { render, staticRenderFns } from "./SimilarLoans.vue?vue&type=template&id=238d65c2&scoped=true&"
import script from "./SimilarLoans.vue?vue&type=script&lang=js&"
export * from "./SimilarLoans.vue?vue&type=script&lang=js&"
import style0 from "./SimilarLoans.vue?vue&type=style&index=0&id=238d65c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238d65c2",
  null
  
)

export default component.exports